// extracted by mini-css-extract-plugin
export var container = "_3o-0";
export var icon = "_3o-1";